module.exports = __webpack_public_path__ + "static/khadas-4ae4e78ba50cfd6b01440e00bea8a0c6.png";